import React from 'react';
import {map} from 'lodash';
import Label from 'shared/components/label';
import Dropdown from 'src/components/dropdown';
import {US_ABBV_MAP} from 'shared/utils';

interface Props {
  state: string;
  onChange: (state: string) => void;
}

const StateSelect = ({state, onChange}: Props) => {
  const stateOptions = map(US_ABBV_MAP, (name, value) => ({
    text: name,
    value: value,
  }));

  return (
    <Label>
      State
      <Dropdown
        onChange={(e) => {
          onChange(e.target.value);
        }}
        options={stateOptions}
        value={state || ''}
      />
    </Label>
  );
};

export default StateSelect;
